import assetPath from '/app/packages/lebenslauf/constants/src/assets/cover-letter-1-preview.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')